import React from "react";
import Layout from "../../Components/Layout/Layout";
import AtlasChatComponent from "../../Components/AtlasChatComponent/AtlasChatComponent";

const AtlasChatPage = () => {
  return (
    <Layout>
      {/* <div className="child-section-of-everypage-aipath"> */}
        <AtlasChatComponent />
      {/* </div> */}
    </Layout>
  );
};

export default AtlasChatPage;
